import { render, staticRenderFns } from "./FloatingHomeButton.vue?vue&type=template&id=0d1d7d70"
import script from "./FloatingHomeButton.vue?vue&type=script&lang=js"
export * from "./FloatingHomeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports